import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
import { stringify } from "query-string";
import withViewport from "../Viewport/withViewport";
import withTranslation from "../translation";
import styles from "./index.css";
import IconNotification from "../IconNotification";
import { getMyAccountBaseUrl } from "../../helpers/externalLinks";
import classnames from "classnames";
import { tabIndex } from "../../../helpers/accessibility";

const CONTACT_PREFERENCES = "ContactPreferences";
const MY_ACCOUNT = "MyAccount";
const MY_ORDERS = "MyOrders";
const RETURNS_INFORMATION = "ReturnsInformation";
const MY_ACCOUNT_CRISTMAS_LOGGEDOUT = "MyAccountChristmasLoggedOut";
const MY_ACCOUNT_CRISTMAS_LOGGEDIN = "MyAccountChristmasLoggedIn";

const cx = classnames.bind(styles);

class MyAccountLinks extends PureComponent {
  static propTypes = {
    countryCode: PropTypes.string.isRequired,
    defaultStoreUrl: PropTypes.string.isRequired,
    eventIconToggle: PropTypes.oneOfType([
      PropTypes.shape({
        christmas: PropTypes.bool
      }),
      PropTypes.bool
    ]),
    focusable: PropTypes.bool,
    formatTranslation: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    isReconsentRequired: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool,
    keyStoreDataversion: PropTypes.string.isRequired,
    lang: PropTypes.string.isRequired,
    queryParams: PropTypes.object,
    storeCode: PropTypes.string.isRequired
  };

  buildLinks() {
    const {
      countryCode,
      defaultStoreUrl,
      formatTranslation,
      isReconsentRequired,
      keyStoreDataversion,
      lang,
      queryParams = {},
      storeCode
    } = this.props;

    const queryString =
      "?" +
      stringify({
        ...queryParams,
        lang,
        store: storeCode,
        country: countryCode,
        keyStoreDataversion
      });

    const baseUrl = getMyAccountBaseUrl();

    const links = [
      {
        id: MY_ACCOUNT,
        href: baseUrl + queryString,
        showNotification: false
      },
      {
        id: MY_ORDERS,
        href: `${baseUrl}/orders${queryString}`,
        showNotification: false
      },
      {
        id: RETURNS_INFORMATION,
        href: defaultStoreUrl.concat(
          formatTranslation(`MyAccountLinks.${RETURNS_INFORMATION}Link`),
          "&",
          stringify(queryParams)
        ),
        showNotification: false
      },
      {
        id: CONTACT_PREFERENCES,
        href: `${baseUrl}/contact-preferences${queryString}`,
        showNotification: isReconsentRequired
      }
    ];

    return links;
  }

  render() {
    const {
      eventIconToggle,
      focusable,
      formatTranslation,
      isLoggedIn,
      isVisible
    } = this.props;

    const { christmas } = eventIconToggle;
    const eventIconWithLoggedInStatus = isLoggedIn
      ? MY_ACCOUNT_CRISTMAS_LOGGEDIN
      : MY_ACCOUNT_CRISTMAS_LOGGEDOUT;

    if (!isVisible) return null;

    return (
      <Fragment>
        {this.buildLinks().map(({ id, href, showNotification }) => (
          <a
            href={href}
            className={cx(
              styles.link,
              christmas && id === MY_ACCOUNT
                ? styles[eventIconWithLoggedInStatus]
                : styles[id]
            )}
            key={id}
            tabIndex={tabIndex(focusable)}
            data-testid={`${id.toLowerCase()}-link`}
          >
            {showNotification && (
              <span className={cx(styles.notificationContainer)}>
                <IconNotification />
              </span>
            )}
            {formatTranslation(`MyAccountLinks.${id}`)}
          </a>
        ))}
      </Fragment>
    );
  }
}

MyAccountLinks.defaultProps = {
  eventIconToggle: {
    christmas: false
  }
};

export default withViewport(withTranslation(MyAccountLinks));



// WEBPACK FOOTER //
// ./template/components/MyAccountLinks/MyAccountLinks.js